import { render, staticRenderFns } from "./about_section.vue?vue&type=template&id=4c1ff215&scoped=true"
import script from "./about_section.vue?vue&type=script&lang=js"
export * from "./about_section.vue?vue&type=script&lang=js"
import style0 from "./about_section.vue?vue&type=style&index=0&id=4c1ff215&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ff215",
  null
  
)

export default component.exports